<mat-card class="sign-in-card">
  <mat-card-header class="sign-in-header">
    <div class="logo" role="img" aria-label="Damotech"></div>
    <div class="avatar" role="img" aria-label="User"></div>
    <div>{{ 'signin.title' | translate }}</div>
  </mat-card-header>

  <div class="sign-in-content">
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="fields">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'signin.email.title' | translate }}</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email" />
            <mat-icon matPrefix>email</mat-icon>
            @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
              <mat-error>{{ 'signin.email.required' | translate }}</mat-error>
            } @else if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
              <mat-error>{{ 'signin.email.invalid' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{ 'signin.password.title' | translate }}</mat-label>
            <input matInput [type]="hidePassword() ? 'password' : 'text'" formControlName="password" autocomplete="current-password" />
            <mat-icon matPrefix>lock</mat-icon>
            <button mat-icon-button matSuffix type="button" (click)="hidePassword.set(!hidePassword())" [attr.aria-label]="'signin.password.aria' | translate">
              <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
              <mat-error>{{ 'signin.password.required' | translate }}</mat-error>
            } @else if (form.get('password')?.hasError('minlength') && form.get('password')?.touched) {
              <mat-error>{{ 'signin.password.minLength' | translate }}</mat-error>
            }
          </mat-form-field>
        </div>

        @if (errorMessage()) {
          <p class="error-message">{{ errorMessage() }}</p>
        }

        <button mat-flat-button color="primary" type="submit" class="btn" [disabled]="loading()">
          @if (loading()) {
            <mat-spinner diameter="20" />
          } @else {
            {{ 'signin.submit' | translate }}
          }
        </button>
      </form>
    </mat-card-content>

    <mat-card-actions class="sign-in-actions">
      <a mat-button [routerLink]="forgotPassword()" class="forgot-password-link">
        {{ 'signin.password.forgot' | translate }}
      </a>
    </mat-card-actions>
  </div>
</mat-card>
